import { Cardapio } from '../shared/entity/Cardapio';
import { GetManyParams, GetOneParams } from '../shared/types/TypeormTypes';
import { FindManyReq, FindOneReq } from '../shared/types/TypeormTypes';
import api from './api';

const BASE_URL = '/cardapio';

class cardapioApi {
  async getMany(query: GetManyParams<Cardapio>) {
    try {
      let res = await api.post<Cardapio[]>(BASE_URL + '/get', { query });
      let data = res.data;
      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
  async getOne(query: GetOneParams<Cardapio>) {
    try {
      let res = await this.getMany({ ...query, take: 1 });
      if (!res.length) {
        throw new Error('Cardápio não encontrado.');
      }
      return res[0];
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async count(query: GetManyParams<Cardapio>) {
    try {
      let res = await api.post<number>(BASE_URL + '/count', { query });
      let data = res.data;
      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async update(where: Partial<Cardapio>, update: Partial<Cardapio>) {
    try {
      let res = await api.put(BASE_URL, { update }, { params: where });
      let data = res.data;
      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async insert(cardapio: Partial<Cardapio>) {
    try {
      let res = await api.post<Cardapio>(BASE_URL, { cardapio });
      let data = res.data;
      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async delete(params: Partial<Cardapio>) {
    try {
      let res = await api.delete<Cardapio>(BASE_URL, { params });
      let data = res.data;
      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async getCardapioCompleto(params: {
    cardapioId?: string | number;
    empresaId?: string | number;
    promocaoId?: string | number;
  }) {
    try {
      let res = await api.get<Cardapio>(BASE_URL + '/completo', { params });
      let data = res.data;
      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async getCardapiosCompletos() {
    try {
      let res = await api.get<Cardapio[]>(BASE_URL + '/completos');
      let data = res.data;
      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
}

export default new cardapioApi();
